// config.js
export default {
  base_url:'https://trainerapi.akkuratebank.com'
}